<template>
<div>
	<NewMaintenance :powerTypeList="['PV']" :systemType="systemType" :systemTypeId="systemTypeId" :systemTypeName="systemTypeName" ref="NewMaintenance"></NewMaintenance>
    <div class="panel bgPanel ml1x mr1x mb1x pt1x">
		<div class="tableSys vaM_E">
			<div class="pl1x"><span class="fs14x">{{$t("word1978",["维保记录列表"])}}</span></div>
			<div class="taC">
				<InputText class="w20x dpIB bgContent" name="searchKey" 
					:placeholder="getLanguageStr('word2005','输入维保记录名称')" 
					:clearBtn="true" ref="searchBox" :searchBtn="true" v-model="searchText" :fn="getList" @AfterClear="getList"></InputText>
			</div>
			<div class="taR pr1x ml1x_E">
				<button class="functionBtn sizeM"  type="button" v-permissions="'C/A/A4'" permission-type="none" @click="newMaintenance(null)">{{getLanguageStr("word1993","添加新维保记录")}}</button> 
			</div>
		</div>
		<!-- <div class="splitLine mt1x"></div> -->
		<List class="mt1x bdSub-top" :searchText="searchText" @Edit="newMaintenance" :systemType="systemType" :systemTypeId="systemTypeId" ref="List"></List>
	</div>
</div>
</template>
<script>
import List from "@/view/application/maintenance/part/List.vue";
import NewMaintenance from '@/view/application/maintenance/part/NewMaintenance.vue'
import InputText from "@/components/common/ui/InputText.vue";
import * as lib from '@/util/lib'
export default {
	  name: 'display',
	  components:{List,InputText,NewMaintenance},
	  props: {
		  systemType: {
				type: Number,
				default: 1
			},
			systemTypeId: {
				type: Number,
				default: null
			},
			systemTypeName:{
				type: String,
				default: null
			}
		},
	  data () {
		    return {
		    		searchText:"",//搜索文本
		    		newShow:false
		    }
	    },
	 methods:{
	 	getLanguageStr,
		getList:function(){
			this.$refs.List.searchKey();
		},
		newMaintenance(data){
			if (!data) {
				if (this.$route.path.indexOf('application') !== -1) {
				statistic('A41', 'A4102')
			} else {
				statistic('A34', 'A3402')
				}
     		}
			  // this.newShow=true;
			this.$nextTick(() => {
        	 this.$dynamic($(this.$el).parents("#app"),NewMaintenance,{systemType:this.systemType,systemTypeId:this.systemTypeId,systemTypeName:this.systemTypeName,powerTypeList:["PV"]},{}).then(({instance, childInstance})=>{
            	childInstance.show(data,instance)
          })
        });
		}
	 },
  mounted () {
    lib.fillHeight()
    this.$bus.$on('getL',this.getList.bind(this))
  },
  destroyed(){
    this.$bus.$off('getL')
  }
}
</script>

<style lang="scss" scoped> 
</style>


// WEBPACK FOOTER //
// src/view/application/maintenance/List.vue